import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./Reducers/userReducers.js";
import loginReducer from "./Reducers/loginReducer.js";

const store = configureStore({
    reducer: {
        user: userReducer,
        login: loginReducer
    }
});

export default store;